import React from "react";
import styled from "styled-components";
import { TfiClose } from "react-icons/tfi";
import { static_server } from "../../../utils/constants";

const CivSelectorOverlay = ({ civs, side, onSelect, onClose }) => {
  return (
    <Overlay>
      <OverlayInner>
        <OverlayHeader>
          <OverlayTitle>Civilización {side === "A" ? "A" : "B"}</OverlayTitle>
          <CloseBtn onClick={onClose}>
            <TfiClose />
          </CloseBtn>
        </OverlayHeader>
        <OverlayGrid>
          {civs.map((civ) => (
            <OverlayItem
              key={`civ-${side}-${civ.id}`}
              onClick={() => onSelect(civ.name)}
            >
              <OverlayImg
                src={`${static_server}/civs/${civ.name.toLocaleLowerCase()}.png`}
                alt={civ.name}
              />
              <OverlayLabel>{civ.name}</OverlayLabel>
            </OverlayItem>
          ))}
        </OverlayGrid>
      </OverlayInner>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const OverlayInner = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.5rem;
  max-width: 900px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
`;

const OverlayHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const OverlayTitle = styled.h3`
  font-family: var(--v-font-mono);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-mint);
  margin: 0;
`;

const CloseBtn = styled.div`
  color: var(--v-fg-muted);
  cursor: pointer;
  font-size: 18px;
  display: flex;

  &:hover {
    color: var(--v-fg);
  }
`;

const OverlayGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
`;

const OverlayItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 12px;
  transition: background var(--v-transition);

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
`;

const OverlayImg = styled.img`
  width: 6rem;
  height: 4rem;
  object-fit: contain;
  filter: grayscale(100%);
  transition: filter var(--v-transition);

  ${OverlayItem}:hover & {
    filter: grayscale(0);
  }
`;

const OverlayLabel = styled.span`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--v-fg-muted);
`;

export default CivSelectorOverlay;
